import React, { useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "./AuthContext";

// Usa caminho relativo para a API (será tratado pelo proxy do Nginx)
const API_URL = "/api";

export default function Login({ onSwitch }) {
  const { login } = useContext(AuthContext);
  const [usernameOrEmail, setUsernameOrEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/login`, {
        username: usernameOrEmail.includes("@") ? undefined : usernameOrEmail,
        email: usernameOrEmail.includes("@") ? usernameOrEmail : undefined,
        password
      });
      login(res.data.user, res.data.token);
    } catch (err) {
      setError(
        err.response?.data?.error || "Erro ao fazer login. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuário ou E-mail"
            value={usernameOrEmail}
            onChange={e => setUsernameOrEmail(e.target.value.toLowerCase())}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
          {error && <div className="error-message">{error}</div>}
        </form>
        <p>
          Don't have an account?{' '}
          <button className="link-btn" onClick={onSwitch}>
            Register
          </button>
        </p>
      </div>
    </div>
  );
}
